import styled from "styled-components";

export const Container = styled.div`
  padding: 20px;
  min-height: 280px;
  display: flex;
  flex-direction: column;
  .no-result {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
  }
  h2 {
    font-size: 0.875rem;
    font-weight: 700;
    display: flex;
    gap: 20px;
  }
`;

export const BodyModal = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  h2 {
    font-size: 0.875rem;
    font-weight: 700;
    display: flex;
    gap: 20px;
    padding-bottom: 5px;
  }

  .item {
    display: flex;
    gap: 20px;
    justify-content: space-between;
    align-items: center;
    margin: 5px 0;
    label {
    }
    .val {
    }
  }
`;
